import { Callable } from '@vimeo/core/types/generic';

/**
 * Lambda styled 'range' for chaining with map/reduce methods etc.
 */
export function range(length: number): Array<number> {
  return Array.from(new Array(length)).map((it, index) => index);
}

/**
 * Prettier alternative for self invocation functions.
 */
export function inline<T>(callback: Callable<T>): T {
  return callback();
}

/**
 * Prettier alternative for self invocation functions.
 * Allows inline error handling with fallback to some value.
 */
export function safeInline<T>(callback: Callable<T>, fallback: T): T {
  try {
    return callback();
  } catch {
    return fallback;
  }
}
